<script setup lang="ts">
const { t } = useI18n();
const authStore = useAuthStore();
const { exitImpersonation } = useImpersonation();
</script>

<template>
  <div
    v-if="authStore.impersonation"
    class="fixed inset-x-0 top-0 z-[9999] flex items-center justify-center gap-3 bg-gold-primary-120 px-4 py-2 text-[13px] font-semibold text-white shadow-md"
  >
    <i18n-t
      keypath="shell.impersonationBanner.viewingAs"
      tag="span"
    >
      <template #name>
        <strong>{{ authStore.impersonation.agentName }}</strong>
      </template>
    </i18n-t>
    <button
      type="button"
      class="rounded-full bg-white/20 px-3 py-1 text-white hover:bg-white/30"
      @click="exitImpersonation"
    >
      {{ t('shell.impersonationBanner.exit') }}
    </button>
  </div>
</template>
